import { render } from "./VueButton.vue?vue&type=template&id=46d95e7e&scoped=true"
import script from "./VueButton.vue?vue&type=script&lang=js"
export * from "./VueButton.vue?vue&type=script&lang=js"

import "./VueButton.vue?vue&type=style&index=0&id=46d95e7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d95e7e"]])

export default __exports__